<template>
  <div
    v-if="item?.salesPackageSize"
    :class="{
      'product-package-size-fi': true,
      'product-package-size-fi--align-right': alignRight,
    }"
  >
    {{ noBrackets ? '' : '(' }}{{ packageSize }} {{ sellingUnit }} / {{ sellingPackage
    }}{{ noBrackets ? '' : ')' }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useSellingUnits } from '@/composables/sellingUnit';
import type { HybrisFischerBestPrice } from '@/generated/graphql';

defineOptions({
  name: 'ProductPackageSizeFi',
});

const props = defineProps<{
  item?: HybrisFischerBestPrice | null;
  alignRight?: boolean;
  noBrackets?: boolean;
}>();

const { getSellingUnit, getSellingPackage } = useSellingUnits();

const defaultPackage = computed(() =>
  props.item?.alternativeUnits?.find((el) => el?.denominator === el?.numerator),
);

const alternativeUnit = computed(() =>
  props.item?.alternativeUnits?.find((el) => el?.unit === props.item?.salesPackageUnit),
);

const packageSize = computed(() => {
  if (props.item?.alternativeUnits?.length && props.item?.salesPackageUnit) {
    if (alternativeUnit.value) {
      return alternativeUnit.value.denominator >= alternativeUnit.value.numerator
        ? alternativeUnit.value.denominator
        : alternativeUnit.value.numerator;
    }
  }

  return props.item?.salesPackageSize;
});

const sellingUnit = computed(() => {
  if (
    props.item?.salesPackageUnit &&
    (!alternativeUnit.value || alternativeUnit.value.denominator > alternativeUnit.value.numerator)
  ) {
    return getSellingUnit(props.item?.salesPackageUnit);
  }

  return getSellingUnit(defaultPackage.value?.unit || '');
});

const sellingPackage = computed(() => {
  if (
    props.item?.salesPackageUnit &&
    alternativeUnit.value &&
    alternativeUnit.value.denominator >= alternativeUnit.value.numerator
  ) {
    return getSellingPackage(defaultPackage.value?.unit || '');
  }

  return getSellingPackage(props.item?.salesPackageUnit);
});
</script>

<style scoped src="./product-package-size-fi" />
